import { gql, useQuery } from "@apollo/client";

export function useLibraryContentsPaginated(search : string, source : number, page : number, limit : number) {
  return useQuery(
    gql`
      query getLibraryContentsPaginated($search : String, $source : Int, $page : Int, $limit : Int) {
        library_content_images(search : $search, source : $source, page : $page, limit : $limit) {
          total_pages
          page
          docs {
            image_ids
            name
            description
          }
        }
      }
    `,
    {
        variables : {
            search,
            source,
            page,
            limit
        },
        fetchPolicy : 'network-only'
    }
  );
}

export function useLibraryContentsVideosPaginated(search : string, source : number, page : number, limit : number) {
  return useQuery(
    gql`
      query getLibraryContentsVideosPaginated($search : String, $source : Int, $page : Int, $limit : Int) {
        library_content_videos(search : $search, source : $source, page : $page, limit : $limit) {
          total_pages
          page
          docs {
            video_id
            name
            description
          }
        }
      }
    `,
    {
        variables : {
            search,
            source,
            page,
            limit
        },
        fetchPolicy : 'network-only'
    }
  );
}
